import { useEffect, useState } from "react";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import { useSelector } from "react-redux";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import TapSelect from "../../../components/ui/TapSelect";
import tapIcon from '../../../services/TapIcon';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { Helmet } from "react-helmet";
import Ax from "../../../components/hoc/Ax";
import { toast } from "react-toastify";

export default function AssetTypeAdd({history, location}) {

    const assetTypeUrl          =   BACKOFFICE_BASE_URL + '/asset_type';
    const access_token      =   useSelector(state => state.auth.access_token);

    const initAddModelForm  =   {
        asset_type_name         :   '',   
        section_ids             :   [],
        engine_number           :   'no',   
        chasis_number           :   'no',   
        slave_engine            :   'no',   
        fuel_feed_in            :   'no',   
        mvr                     :   'no', 

        hour_meter              :   'no',   
        hour_meter2             :   'no',   
        hour_meter3             :   'no',   
        hour_meter4             :   'no',   
        odo_meter               :   'no',   
        odo_meter2              :   'no',   
        odo_meter3              :   'no',   
        operation_cycle         :   'no',   
        operation_cycle2        :   'no',   
    };
    
    const [addModelForm, setAddModelForm] = useState({ ...initAddModelForm });
    const [saveFormSubmitting, setSaveFormSubmitting]   =   useState(false);
    const [formDataLoading, setFormDataLoading] =   useState(false);
    const [formData, setFormData]   =   useState({
        odoMeters   :   [],
        sections    :   [],
        attributes  :   [],
    });
    const [editId, setEditId]       =   useState(null)
    const [nameExit, setNameExit]   =   useState(false);
    const [editName, setEditName]   =   useState('');
    const [searchExitName, setSearchExitName] = useState(false);

    useEffect(() => {
        initFormData()
         const queryParams = new URLSearchParams(location.search);
         if(queryParams && queryParams.get('asset_type_id')) {
            detailData(queryParams.get('asset_type_id'));
         }
    }, []);

    const initFormData  =   ()  =>  {
        setFormDataLoading(true);
        setNameExit(false);
        HttpAPICall.withAthorization('GET', assetTypeUrl + '/form_data', access_token, {}, {}, (resp) => {
            const respData = resp.data;
            setFormData({
                odoMeters   :   respData.odo_meter,
                sections    :   respData.sections.map(s => ({label : s.component, value : s.id})),
                attributes  :   respData.attributes
            })
        }).then(() => setFormDataLoading(false));
    }

    const detailData    =   (id) => {
        setEditId(id);
        HttpAPICall.withAthorization('GET', assetTypeUrl + '/detail/' + id, access_token, {}, {}, (resp) => {
            const respData = resp.data;
            let data    =   {};
            respData.attributes?.forEach(a => {
                data = {...data, [a.key] : a.value}
            })
            respData.odo_meters?.forEach(a => {
                data = {...data, [a.key] : a.active === 'Y' ? 'yes' : 'no'}
            })    
            setAddModelForm({
                asset_type_name : respData.asset_type_name,
                section_ids : respData.sections.map(d => d.id),
                ...data
            })
            setEditName(respData.asset_type_name)
        });
    }

    const handleRadioChange = (e, field) => {
        const { value } = e.target;
        setAddModelForm(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    const submitDataForm = (e) => {
        e.preventDefault();
        setSaveFormSubmitting(true);
        let method  =   'POST';
        let url     =   assetTypeUrl + '/add';
        let payload =   addModelForm;
        if(editId) {
            method  =   'PUT';
            url     =   assetTypeUrl + '/edit';
            payload =   {...payload, id : editId};
        }

        HttpAPICall.withAthorization(method, url, access_token, {}, payload, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            goToList();
        }).catch((error) => {
            toast.error(error.response?.data?.msg || "An error occurred", { position: toast.POSITION.TOP_RIGHT });
        }).finally(() => {
            setSaveFormSubmitting(false);
        });
    };

    const goToList  =   ()  => {
        setAddModelForm(initAddModelForm);
        setEditId(null);
        setEditName('');
        setNameExit('');
        setNameExit(false);
        history.push('/asset_type_list');
    }

    const handleBlur    =   ()  => {
        const {asset_type_name} = addModelForm
        if(asset_type_name && asset_type_name !== editName) {
            setEditName(asset_type_name);
            setSearchExitName(true);
            HttpAPICall.withAthorization('GET', assetTypeUrl + '/with_name?asset_type_name=' + asset_type_name, access_token, {}, {}, (resp) => {
                if(resp.data > 0) {
                    setNameExit(true)
                }else {
                    setNameExit(false)
                }
            }).then(() => setSearchExitName(false));
        }
    }


    const saveFormJsx   =   ()  =>  {
        return(
            <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                {formDataLoading ? <Loader />
                    : <>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="name" className="form-label require">Name</label>
                            </div>
                            <div className="col-sm-6 ">
                                <input
                                    name="asset_type_name"
                                    type="text"
                                    value={addModelForm.asset_type_name}
                                    className="form-control"
                                    autoComplete="off"
                                    required={true}
                                    onChange={(e) => {
                                        setAddModelForm(pre => ({...pre, [e.target.name] : e.target.value}))
                                    }}
                                    onBlur={handleBlur}
                                    placeholder="Please enter Name"
                                />
                            {
                                nameExit && 
                                    <span className="text-danger">* Asset Type not available,try another</span>
                            }
                            </div>
                        </div>

                        <div className="row align-items-center my-3">
                            <div className="col-sm-3">
                                <label htmlFor="path" className="form-label">Section Applicable</label>
                            </div>
                            <div className="col-sm-6 ">
                                <TapSelect
                                    changeEvent={(selectedOption) => {
                                        if(selectedOption) {
                                            setAddModelForm(pre => ({...pre, section_ids : selectedOption.map(d => d.value)}))
                                        }else {
                                            setAddModelForm(pre => ({...pre, section_ids : []}))
                                        }
                                    }}
                                    options={formData.sections}
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti={true}
                                    required={true}
                                    value={formData.sections.filter(s => addModelForm.section_ids.includes(s.value))}
                                    placeholder={"Please Select Section"}
                                />
                            </div>
                        </div>
                        <div className="row align-items-center my-3">
                            <div className="col-sm-12">
                                <label htmlFor="path" className="form-label">Attributes Applicable</label>
                            </div>
                        {formData.attributes.map((field, index) => (
                            <Ax key={field.key}>
                                <div className="col-sm-3">
                                    <label className="form-label">{field.label}</label>
                                </div>
                                <div className="col-sm-3">
                                    <div className="d-flex align-items-center">
                                        <div className="form-check me-3">
                                            <input
                                                type="radio"
                                                id={`yes-${index}`}
                                                className="form-check-input"
                                                name={field.key} 
                                                value="yes"
                                                checked={addModelForm[field.key] === 'yes'}
                                                onChange={(e) => handleRadioChange(e, field.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`yes-${index}`}>Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                id={`no-${index}`}
                                                className="form-check-input"
                                                name={field.key} 
                                                value="no"
                                                checked={addModelForm[field.key] === 'no'}
                                                onChange={(e) => handleRadioChange(e, field.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`no-${index}`}>No</label>
                                        </div>
                                    </div>
                                </div>
                            </Ax>
                        ))}
                        </div>

                        <div className="row align-items-center my-3">
                            <div className="col-sm-12">
                                <label htmlFor="path" className="form-label">Meters Applicable</label>
                            </div>
                        {formData.odoMeters.map((field, index) => (
                            <Ax key={field.key}>
                                <div className="col-sm-3">
                                    <label className="form-label">{field.label}</label>
                                </div>
                                <div className="col-sm-3">
                                    <div className="d-flex align-items-center">
                                        <div className="form-check me-3">
                                            <input
                                                type="radio"
                                                id={`yes-${field.key}`}
                                                className="form-check-input"
                                                name={field.key} 
                                                value="yes"
                                                checked={addModelForm[field.key] === 'yes'}
                                                onChange={(e) => handleRadioChange(e, field.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`yes-${field.key}`}>Yes</label>
                                        </div>
                                        <div className="form-check">
                                            <input
                                                type="radio"
                                                id={`no-${field.key}`}
                                                className="form-check-input"
                                                name={field.key} 
                                                value="no"
                                                checked={addModelForm[field.key] === 'no'}
                                                onChange={(e) => handleRadioChange(e, field.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`no-${field.key}`}>No</label>
                                        </div>
                                    </div>
                                </div>
                            </Ax>
                        ))}
                        </div>

                    </>}
                <div className="col-12 text-end fixed_footer">
                    <button type="button" disabled={saveFormSubmitting} onClick={goToList} className="btn btn-secondary mx-3">Cancel</button>
                    <button type="submit" disabled={saveFormSubmitting || formDataLoading || searchExitName} className="btn btn-primary mx-2">
                        Save {saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                    </button>
                </div>
            </form>
        )
    } 


  return (
    <ApplicationLayout>
        <Helmet><title>Asset Type Add</title></Helmet>
        <div className="page_title row m0">
            <div className="col-12">
                <h3>{editId ? "Edit" : "Add"} Asset Type</h3>
                <div className="text-end mt15">
                    <button type="button" className="btn btn-secondary" onClick={goToList}>
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Asset Type" />
                    </button>
                </div>
            </div>
        </div>
        {/* onClick={closeEvent} disabled={saveFormSubmitting} */}
        <div className="container-fluid">
            <div className="page_containt row pl2">
                <div className="pageTbl col-12 pl4">
                    {saveFormJsx()}
                </div>
            </div>
        </div>
    </ApplicationLayout>
  )
}
